export default "__VITE_ASSET__d6457933__"